import Utility from "../utility/utility";
import AppData from "../pacakge/public/const/app_data";
import GameUtil from "../utility/game_util";
import LoaclStorage from "../manager/local_storage";
import TimeManager from "../manager/time_manager";
import EventManager from "../manager/event_manager";
import ModelData from "../pacakge/public/model_data";
import ModuleManager from "../framework/core/module_manager";
import LanguageManager from "../manager/language_manager";
import AppController from "./app_controller";
import UserDataManager from "../manager/user_manager";
import IAPController from "./iap_controller";
import LogManager from "../manager/log_manager";
// import Test from "../pacakge/hall/module/test/test";

export default class GoogleBillingController extends cc.Component {

    public static receive(content: string, encode = true) {
        let json = JSON.parse(encode ? Utility.decodeBase64(content) : content);
        LogManager.instance.log(`GoogleBilling receive funcName: ${json.funcName} jsonParam: ${json.param}`, true)
        if (json.funcName == "queryPurchaseHistoryAsyncSubsReturn") { //内购历史订单返回
            cc.systemEvent.off("googleBillingOnQueryReturnRecheck")
            this.historyDeal(json.param, SkuType.SUBS)
        } else if (json.funcName == "queryPurchaseHistoryAsyncInAppReturn") { //订阅历史订单返回
            cc.systemEvent.off("googleBillingOnQueryReturnRecheck")
            this.historyDeal(json.param, SkuType.INAPP)
        } else if (json.funcName == "googleBillingInit") {  //初始化
            cc.log("GoogleBillingInit 初始化成功")
        } else if (json.funcName == "googleBillingOnQueryReturn") {  //商品查询返回商品json数组
            let data = JSON.parse(json.param)
            let skud: string = data.SkuDetails
            let skuDetails: string[] = skud.split("#@#")
            var skuDetailsObj = new Array(skuDetails.length)
            for (let i = 0; i < skuDetails.length; i++) {
                skuDetailsObj[i] = JSON.parse(skuDetails[i])
                cc.log("GoogleBillingQuery", skuDetailsObj[i].getSku, skuDetailsObj[i].getPriceCurrencyCode, skuDetailsObj[i].getPrice, skuDetailsObj[i].getPriceAmountMicros)
            }
            if (data.str == "recheck") {
                cc.systemEvent.emit("googleBillingOnQueryReturnRecheck", skuDetailsObj)
            } else {
                EventManager.instance.dispatch("googleBillingOnQueryReturn", skuDetailsObj)
            }
        } else if (json.funcName == "googleBillingOnRecheck") {    //补单
            let billingData = JSON.parse(json.param)
            if (billingData.getPurchaseState == PurchaseState.PURCHASED && !billingData.isAcknowledged) {
                cc.systemEvent.off("googleBillingOnQueryReturnRecheck")
                this.queryRecheckAck(billingData.getSku, billingData.getPurchaseToken, billingData.getPackageName, billingData.skuType)
            }
        } else if (json.funcName == "googleBillingPurchaseSuccess") {  //购买结果返回
            let data = JSON.parse(json.param)
            let sku = JSON.parse(data.skuDetails)
            // ModuleManager.instance.showModule("NetPrompt")
            if (data.getPurchaseState == PurchaseState.PURCHASED) {
                cc.log("购买成功", data.skuDetails)
                this.createOrder(data.getSku, data.getPurchaseToken, data.getPackageName, sku.getPriceAmountMicros / 1000000, sku.getPriceCurrencyCode, data.skuType)
            } else if (data.getPurchaseState == PurchaseState.PENDING) {
                cc.log("等待支付，暂时不处理")
            } 
        } else if (json.funcName == "googleBillingConsumeSuccess") {   //交易确认返回
            EventManager.instance.dispatch("googleBillingConsumeSuccess", json.param)
            cc.log("交易确认成功")
        } else if (json.funcName == "googleBillingOperateFail") {  //操作失败
            let op = JSON.parse(json.param)
            if (op.tag == "QUERY") {  //查询

            } else if (op.tag == "PURCHASE") {  //购买
                if (op.code == BillingResponseCode.USER_CANCELED) {
                    cc.log("googleBillingError,user cancel bill")
                    ModuleManager.instance.hideModule("NetPrompt")
                } else if (op.code == BillingResponseCode.ITEM_ALREADY_OWNED) {
                    cc.log("googleBillingError,user have own item")
                    ModuleManager.instance.toastKey("google_play_own_item");
                    let pl
                    if (op.skuType == SkuType.INAPP) {
                        pl = this.queryPurchasesInApp()
                    } else if (op.skuType == SkuType.SUBS) {
                        pl = this.queryPurchasesSubs()
                    }
                    pl = JSON.parse(pl)
                    let list: string[] = pl.purchaseList.split("#@#")
                    cc.log("googleBillingError,list", pl.purchaseList, list.length)
                    if (pl.purchaseList == "" || list.length == 0) {
                        if (op.skuType == SkuType.INAPP) {
                            this.queryPurchaseHistoryAsyncInApp()
                        } else if (op.skuType == SkuType.SUBS) {
                            this.queryPurchaseHistoryAsyncSubs()
                        }
                    }
                } else {
                    ModuleManager.instance.hideModule("NetPrompt")
                }

            }
            cc.log("googleBillingOperateFail", json.param)
        } else if (json.funcName == "googleBillingError") {  //错误
            cc.log("googleBillingError", json.param)
        }
    }


    static historyDeal(history, skuType) {
        let historys: string[] = history.split("#@#")
        for (let i = 0; i < historys.length; i++) {
            let data = JSON.parse(historys[i])
            var curTime = TimeManager.instance.getServerTime();
            var purchaseTime = Math.floor(data.getPurchaseTime / 1000)
            cc.log("GoogleBillingHistory", data.getSku, purchaseTime, data.getDeveloperPayload, curTime)
            if (curTime - purchaseTime < 60 * 60 * 24 * 3) {
                this.queryRecheckAck(data.getSku, data.getPurchaseToken, AppData.bundleId, skuType)
            }
        }
    }

    static queryRecheckAck(skuId, token, packageName, skuType) {
        let self = this
        cc.systemEvent.on("googleBillingOnQueryReturnRecheck", function (data) {
            cc.log("googleBillingOnQueryReturnRecheck,", skuId)
            for (let i = 0; i < data.length; i++) {
                let sku = data[i]
                if (sku.getSku == skuId) {
                    self.createOrder(skuId, token, packageName, sku.getPriceAmountMicros / 1000000, sku.getPriceCurrencyCode, skuType)
                }
            }
        })

        cc.log("有未确认的交易，准备确认:", skuId)
        if (skuType == SkuType.INAPP) {
            this.queryInventoryInApp(skuId, "recheck")
        } else if (skuType == SkuType.SUBS) {
            this.queryInventorySubs(skuId, "recheck")
        }
    }


    /**
     * 
     * @param funcName 
     * @param jsonParam 
     */
    public static requestNativeFunc(funcName: string, jsonParam: string = "") {
        if (!CC_JSB) {
            return
        }
        if (cc.sys.os != cc.sys.OS_ANDROID) {
            return
        }
        let jsonObj = {
            "funcName": funcName,
            "params": jsonParam
        };
        let jsonStr = JSON.stringify(jsonObj);
        cc.log("googleBilling requestNativeFunc", jsonStr)
        let className = "project/sdk/GoogleBilling";
        jsb.reflection.callStaticMethod(className, "receiveJSCall", "(Ljava/lang/String;)V", jsonStr);
    }

    /**
 * 
 * @param funcName 
 * @param jsonParam 
 */
    public static requestNativeFuncReturn(funcName: string, jsonParam: string = ""): string {
        if (!CC_JSB) {
            return
        }
        if (cc.sys.os != cc.sys.OS_ANDROID) {
            return
        }
        let jsonObj = {
            "funcName": funcName,
            "params": jsonParam
        };
        let jsonStr = JSON.stringify(jsonObj);
        let result: string
        let className = "project/sdk/GoogleBilling";
        LogManager.instance.log(`GoogleBilling request funcName: ${funcName} jsonParam: ${jsonParam}`, true)
        result = jsb.reflection.callStaticMethod(className, "receiveJSCallReturn", "(Ljava/lang/String;)Ljava/lang/String;", jsonStr);
        return result
    }

    public static createOrder(skuid, token, packageName, price, currency, skuType) {
        cc.log("开始请求确认")
        let requestData: IHttpRequestData = {
            baseUrl: "order/purchaseInnerOrder?",  ///mobile/order/purchaseInnerOrder
            params: {
                currency: currency,//goods.getPriceCurrencyCode,
                goodsCode: skuid,
                onlinePayType: 1,
                price: price,//goods.getPriceAmountMicros / 1000000,
                packageName: packageName,
                purchaseToken: token
            },
            timeOutRequestMinIntervalTime : true,
            logRecord : true
            // timeOutRequestMax: 0
        }
        GameUtil.apiHttpGet(requestData, function (respone) {
            ModuleManager.instance.hideModule("NetPrompt")
            if (respone.code == "X00073" || respone.code == "X00071") {
                cc.log("交易取消")
                GoogleBillingController.purchaseConfirmation(token, skuType, "cancel")
            } else if (respone.code == "SUCCESS") {
                cc.log("已验证通过，准备确认消费")
                // ModuleManager.instance.toastKey("purchase_success");
                UserDataManager.getCurrencyData(ModelData.instance.roleData.id, null, true, true)
                EventManager.instance.dispatch("googleBillingPurchaseSuccess", skuid)
                GoogleBillingController.purchaseConfirmation(token, skuType, "success")
            }
        }, function (err) {
            if (err.code == "X00073" || err.code == "X00071") {
                ModuleManager.instance.hideModule("NetPrompt")
                cc.log("交易取消")
                GoogleBillingController.purchaseConfirmation(token, skuType, "cancel")
            } else if(err.code == "X00027") { //操作太频繁，需要稍后
                setTimeout(() => {
                    GoogleBillingController.createOrder(skuid, token, packageName, price, currency, skuType)
                }, 3000)
            } else {
                ModuleManager.instance.toast500error(err)
                ModuleManager.instance.hideModule("NetPrompt")
            }
        })
    }

    //创建其他订单
    public static createOtherOrder(skuid, payLaneId) {
        cc.log("开始请求确认")
        let requestData: IHttpRequestData = {
            baseUrl: "order/purchase-by-topp?", 
            params: {
                goodsCode: skuid,
                payLaneId: payLaneId
            },
            timeOutRequestMinIntervalTime : true
        }
        GameUtil.apiHttpGet(requestData, function (respone) {
            ModuleManager.instance.hideModule("NetPrompt")
            if (respone.code == "SUCCESS") {
                //打开网页
                cc.sys.openURL(respone.data.value); 
            }
        }, function (err) {
            ModuleManager.instance.hideModule("NetPrompt")
        })
    }
    


    //发起内购购买
    public static purchaseInApp(skuId: string) {
        if (CC_JSB) {
            if (cc.sys.os == cc.sys.OS_ANDROID) {
                if (!Utility.version_judge(AppData.appVersion, "1.2.0")) {
                    ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t("purchase_not_support"), () => {
                        AppController.instance.startApp("market://details?id=" + AppData.bundleId)
                    })
                    ModuleManager.instance.hideModule("NetPrompt")
                } else {
                    this.requestNativeFunc("purchaseInApp", skuId)
                }
            } else if (cc.sys.os == cc.sys.OS_IOS) {
                if (!Utility.version_judge(AppData.appVersion, "1.2.0")) {
                    // ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t("purchase_not_support"), () => {
                    //     AppController.instance.startApp("market://details?id=" + AppData.bundleId)
                    // })
                    ModuleManager.instance.toastKey("purchase_not_open");
                    ModuleManager.instance.hideModule("NetPrompt")
                } else {
                    IAPController.buyProduct(skuId)
                }
            }
            else {
                ModuleManager.instance.toastKey("purchase_not_open");
                ModuleManager.instance.hideModule("NetPrompt")
            }
        } else {
            ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t("purchase_not_support"), () => {
                ModuleManager.instance.hideModule("NetPrompt")
            }, () => {
                ModuleManager.instance.hideModule("NetPrompt")
            })
        }
    }
    //发起订阅购买
    public static purchaseSubs(skuId: string) {
        this.requestNativeFunc("purchaseSubs", skuId)
    }
    // 查询内购商品信息 ,不传skuid则默认查询所有的商品，前提是必须调用setsku方法
    public static queryInventoryInApp(skuId?: string, str?: string) {
        let jsonObj = {
            "skuId": skuId ? skuId : "",
            "str": str
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("queryInventoryInApp", jsonStr)
    }
    // 查询订阅商品信息,不传skuid则默认查询所有的商品，前提是必须调用setsku方法
    public static queryInventorySubs(skuId?: string, str?: string) {
        let jsonObj = {
            "skuId": skuId,
            "str": str
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("queryInventorySubs", jsonStr)
    }
    // 获取已经内购的商品
    public static queryPurchasesInApp() {
        let a = this.requestNativeFuncReturn("queryPurchasesInApp")
        cc.log("googleBilling queryPurchasesInApp", a)
        return a
    }
    //获取已经订阅的商品
    public static queryPurchasesSubs() {
        return this.requestNativeFuncReturn("queryPurchasesSubs")
    }
    //设置skuid，查询后台商品必须先设置需要查询的商品skuid
    public static setSku(goodsSkuIds: string[], subsSkuIds: string[]) {
        let gsi: string = ""
        let ssi: string = ""
        if (goodsSkuIds != null && goodsSkuIds.length > 0) {
            for (let i = 0; i < goodsSkuIds.length; i++) {
                gsi = i == 0 ? goodsSkuIds[i] : gsi + ";" + goodsSkuIds[i]
            }
        }
        if (subsSkuIds != null && subsSkuIds.length > 0) {
            for (let i = 0; i < subsSkuIds.length; i++) {
                ssi = i == 0 ? subsSkuIds[i] : ssi + ";" + subsSkuIds[i]
            }
        }
        let jsonObj = {
            "goodsSkuIds": gsi,
            "subsSkuIds": ssi,
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("setSku", jsonStr)
    }
    //初始化Google支付 ，debug 是否开启调试模式
    public static initBilling(debug: boolean) {
        this.requestNativeFunc("initBilling", debug ? "0" : "1")
    }
    //确认购买
    public static acknowledgePurchase(token: string) {
        this.requestNativeFunc("acknowledgePurchase", token)
    }
    //消耗商品
    public static consumeAsync(token: string) {
        this.requestNativeFunc("consumeAsync", token)
    }
    //异步联网查询所有的内购历史-无论是过期的、取消、等等的订单
    public static queryPurchaseHistoryAsyncInApp() {
        this.requestNativeFunc("queryPurchaseHistoryAsyncInApp")
    }
    //异步联网查询所有的订阅历史-无论是过期的、取消、等等的订单
    public static queryPurchaseHistoryAsyncSubs() {
        this.requestNativeFunc("queryPurchaseHistoryAsyncSubs")
    }
    //断开连接google服务
    public static disconnectGoogleBillingConnect() {
        this.requestNativeFunc("disconnectGoogleBillingConnect")
    }
    //设置开启调试模式
    public static setGoogleBillingDebug(debug: boolean) {
        this.requestNativeFunc("setGoogleBillingDebug", debug ? "0" : "1")
    }
    //确认购买
    public static purchaseConfirmation(token: string, skuType: string, preload: string) {
        let jsonObj = {
            "token": token,
            "skuType": skuType,
            "preLoad": preload
        };
        let jsonStr = JSON.stringify(jsonObj);
        this.requestNativeFunc("purchaseConfirmation", jsonStr)
    }
    //请求订阅数量
    public static getPurchasesSizeSubs(): number {
        let size = this.requestNativeFuncReturn("getPurchasesSizeSubs")
        return parseInt(size)
    }
    //google内购服务是否已经准备好
    public static googleBillingIsReady(): boolean {
        let isready = this.requestNativeFuncReturn("googleBillingIsReady")
        return isready == "0" ? true : false
    }
}
//@ts-ignore
window.googleBillingController = GoogleBillingController;
export enum BillingResponseCode {
    SERVICE_TIMEOUT = -3,
    FEATURE_NOT_SUPPORTED = -2,
    SERVICE_DISCONNECTED = -1,
    OK = 0,
    USER_CANCELED = 1,
    SERVICE_UNAVAILABLE = 2,
    BILLING_UNAVAILABLE = 3,
    ITEM_UNAVAILABLE = 4,
    DEVELOPER_ERROR = 5,
    ERROR = 6,
    ITEM_ALREADY_OWNED = 7,
    ITEM_NOT_OWNED = 8,
}

export enum PurchaseState {
    UNSPECIFIED_STATE = 0,
    PURCHASED = 1,
    PENDING = 2
}
export enum SkuType {
    INAPP = "inapp",
    SUBS = "subs",
}